import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FileText, BarChart3 } from 'lucide-react';
import Layout from '../components/Layout';
import { WeeklyReports } from '../components/reports/WeeklyReports';
import { MonthlyOverview } from '../components/reports/MonthlyOverview';

const TABS = [
  { id: 'weekly', icon: FileText, label: 'reports.tabWeekly' },
  { id: 'monthly', icon: BarChart3, label: 'reports.tabMonthly' },
];

export default function WeeklyPage() {
  const { t } = useTranslation();
  const [tab, setTab] = useState('weekly');
  return (
    <Layout>
      <div data-testid="reports-page">
        <h1 className="text-2xl sm:text-3xl font-bold text-zinc-900 mb-1" style={{ fontFamily: 'Manrope, sans-serif' }}>{t('reports.title')}</h1>
        <p className="text-zinc-600 mb-6 text-sm sm:text-base">{t('reports.subtitle')}</p>
        <div className="inline-flex gap-1 p-1 bg-zinc-100 rounded-xl mb-6" role="tablist">
          {TABS.map(({ id, icon: Icon, label }) => (
            <button key={id} role="tab" aria-selected={tab === id} onClick={() => setTab(id)} data-testid={`reports-tab-${id}`}
              className={`inline-flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-semibold transition-colors ${tab === id ? 'bg-white shadow text-zinc-900' : 'text-zinc-500 hover:text-zinc-800'}`}>
              <Icon className="w-4 h-4" />{t(label)}
            </button>
          ))}
        </div>
        {tab === 'weekly' ? <WeeklyReports /> : <MonthlyOverview />}
      </div>
    </Layout>
  );
}
